import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import useCoreProductCategories from "../../services/useCoreProductCategories";
import CategoryForm from "./CategoryForm";
import CategoryList from "./CategoryList";

/**
 * Página de listagem e cadastro de categorias de produtos (core.ProductCategory)
 */
const CoreProductCategories = () => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string>("");

  const { data: categories, isLoading, error } = useCoreProductCategories();

  const handleFormSuccess = () => {
    setErrorMessage("");
    setSuccessMessage("Categoria criada com sucesso!");
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleError = (message: string) => {
    setSuccessMessage("");
    setErrorMessage(message);
  };

  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: "center" }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error">
          Erro ao carregar categorias. Tente novamente.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1">
          Categorias de Produtos
        </Typography>
      </Box>

      {errorMessage && (
        <Alert
          severity="error"
          onClose={() => setErrorMessage("")}
          sx={{ mb: 3 }}
        >
          {errorMessage}
        </Alert>
      )}

      {successMessage && (
        <Alert
          severity="success"
          onClose={() => setSuccessMessage("")}
          sx={{ mb: 3 }}
        >
          {successMessage}
        </Alert>
      )}

      <CategoryForm onSuccess={handleFormSuccess} onError={handleError} />

      <CategoryList categories={categories || []} onError={handleError} />
    </Container>
  );
};

export default CoreProductCategories;
